import {
    DTOCardFormField, NestedField,
} from 'app/types/form.types'

import {
    AddressMainCategory, ServiceCenterStatus, ServiceCenterType,
} from 'app/enums/label.enums'
import {
    ServiceCenterFormType,
} from '../serviceCenters.types'
import getWorkScheduleFields from '../WorkSchedule/workSchedule.fields'

const getFields = ({
    getAllowedValues,
    isProductionSite,
    isPlannedStatus,
    isLunchBreak,
    hasClientConsignmentStock,
    exists,
    disabled,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    isProductionSite: boolean,
    isPlannedStatus: boolean,
    isLunchBreak: boolean,
    hasClientConsignmentStock: boolean,
    exists: boolean,
    disabled: boolean,
}): DTOCardFormField<keyof ServiceCenterFormType>[] => {
    const operationalDaysFields = getWorkScheduleFields({
        isLunchBreak,
    })

    return [
        {
            id: 'generalInformation',
            title: 'GENERAL_INFORMATION',
            className: 'generalInformation',
            fields: [{
                id: 'column1',
                fields: [
                    {
                        name: 'serviceCenterNumber',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'SERVICE_CENTER_NUMBER',
                    },
                    {
                        name: 'location',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                        required: true,
                        labelKey: 'LOCATION',
                    },
                    {
                        name: 'serviceCenterStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ServiceCenterStatus),
                        required: true,
                        labelKey: 'SERVICE_CENTER_STATUS',
                    },
                    ...isPlannedStatus ? [{
                        name: 'serviceCenterPlannedStartDate',
                        componentName: 'DateSelect',
                        required: true,
                        labelKey: 'PLANNED_START_DATE',
                    }] as NestedField<keyof ServiceCenterFormType>[] : [],
                    {
                        name: 'serviceCenterType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ServiceCenterType),
                        useDropdown: true,
                        required: true,
                        labelKey: 'SERVICE_CENTER_TYPE',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                    {
                        name: 'procurementNotes',
                        componentName: 'LongText',
                        labelKey: 'PROCUREMENT_NOTES',
                    },
                    {
                        name: 'serviceCenterDocumentation',
                        componentName: 'AttachmentsObjectSelector',
                        labelKey: 'SERVICE_CENTER_DOCUMENTATION',
                    },
                    {
                        name: 'estimatedClosureDate',
                        componentName: 'DateSelect',
                        labelKey: 'ESTIMATED_CLOSURE_DATE',
                    },
                ],
            }],
        },
        {
            id: 'serviceCenterMetrics',
            title: 'SERVICE_CENTER_METRICS',
            className: 'serviceCenterMetrics',
            fields: [{
                id: 'column2',
                fields: [
                    ...exists && !disabled ? [] : [
                        {
                            name: 'orderSelectionDelay',
                            componentName: 'IntegerInput',
                            required: true,
                            labelKey: 'ORDER_SELECTION_DELAY',
                        },
                        {
                            name: 'maxTrucksPerDay',
                            componentName: 'IntegerInput',
                            required: true,
                            labelKey: 'MAX_TRUCKS_PER_DAY',
                        },
                        {
                            name: 'processingThroughput',
                            componentName: 'IntegerInput',
                            required: true,
                            labelKey: 'PROCESSING_THROUGHPUT',
                        },
                    ] as NestedField<keyof ServiceCenterFormType>[],
                    {
                        name: 'isAvailableForDropoff',
                        componentName: 'Checkbox',
                        labelKey: 'AVAILABLE_FOR_DROPOFF',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                    {
                        name: 'isAvailableForPickup',
                        componentName: 'Checkbox',
                        labelKey: 'AVAILABLE_FOR_PICKUP',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                ],
            }],
        },
        ...!exists ? operationalDaysFields as DTOCardFormField<keyof ServiceCenterFormType>[] : [],
        ...exists && !disabled ? [] : [{
            id: 'productMetrics',
            title: 'PRODUCT_METRICS',
            className: 'productMetrics',
            fields: [{
                name: 'productMetrics',
                componentName: 'ProductMetrics',
                exists,
                required: true,
            }],
        }] as DTOCardFormField<keyof ServiceCenterFormType>[],
        ...isProductionSite ? [{
            id: 'containerProductionRate',
            title: 'CONTAINER_PRODUCTION_RATE',
            className: 'containerProductionRate',
            fields: [{
                name: 'containerProductionRate',
                componentName: 'ContainerProductionRate',
                required: true,
                exists,
            }],
        }] as DTOCardFormField<keyof ServiceCenterFormType>[] : [],
        {
            id: 'storages',
            title: 'STORAGES',
            className: 'storages',
            fields: [{
                name: 'storages',
                componentName: 'Storages',
                exists,
                required: true,
                disabledFields: {
                    dailyPreconditioningCapacity: exists && !disabled,
                },
            }],
        },
    ]
}

export default getFields
